import { render, staticRenderFns } from "./Asset.vue?vue&type=template&id=3004cf99&scoped=true"
import script from "./Asset.vue?vue&type=script&lang=ts"
export * from "./Asset.vue?vue&type=script&lang=ts"
import style0 from "./Asset.vue?vue&type=style&index=0&id=3004cf99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3004cf99",
  null
  
)

export default component.exports